import React, { useState } from 'react';
import SEO from '../components/SEO';

const Awards = () => {
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Awards data extracted from the PDF
  const awards = [
    {
      id: 1,
      title: 'Best Tour and Travel Award',
      organization: 'Recognized by Bollywood Actor Tushar Kapur',
      year: '2025',
      description: 'Prestigious award presented by Bollywood actor Tushar Kapur for excellence in tour and travel services, outstanding customer satisfaction, and innovative travel solutions.',
      icon: 'fas fa-trophy',
      color: '#FFB703'
    },
    {
      id: 2,
      title: 'Startup Recognition',
      organization: 'Department for Promotion of Industry and Internal Trade (DPIIT)',
      year: '2025',
      description: 'Officially recognized as a startup by DPIIT, Government of India, working in Travel & Tourism Industry and Hospitality sector with a valid certificate of recognition.',
      icon: 'fas fa-rocket',
      color: '#4CC9F0'
    },
    {
      id: 3,
      title: 'Startup UP Recognition',
      organization: 'Department of IT & Electronics, Government of Uttar Pradesh',
      year: '2025',
      description: 'Recognized as a Startup by Department of IT & Electronics, GoUP through Uttar Pradesh Electronics Corporation Ltd. (UPLC) with Registration No. R/STARTUP/UP/LKO/2025/00007340.',
      icon: 'fas fa-certificate',
      color: '#06D6A0'
    },
    {
      id: 4,
      title: 'Commitment to Safe & Honourable Tourism',
      organization: 'Code of Conduct for Safe and Honourable Tourism',
      year: '2024',
      description: 'Pledged commitment to protect all individuals, especially women and children, and conduct business befitting the culture and ethos of our rich heritage.',
      icon: 'fas fa-shield-alt',
      color: '#F72585'
    },
    {
      id: 5,
      title: 'Sustainable Tourism Pledge',
      organization: 'Sustainable Tourism Initiative',
      year: '2024',
      description: 'Committed to fully implement sustainable tourism practices consistent with environment and heritage protection standards for community benefit.',
      icon: 'fas fa-leaf',
      color: '#06D6A0'
    },
    {
      id: 6,
      title: 'NIDHI Recognition',
      organization: 'National Initiative for Developing and Harnessing Innovations',
      year: '2024',
      description: 'Registered with NIDHI ID: EUP000449 for innovation and excellence in travel services.',
      icon: 'fas fa-id-card',
      color: '#FFB703'
    }
  ];

  // Certifications extracted from the PDF
  const certifications = [
    {
      title: 'DPIIT Startup Recognition',
      description: 'Certified by Department for Promotion of Industry and Internal Trade',
      icon: 'fas fa-building',
      date: '2025'
    },
    {
      title: 'UP Startup Recognition',
      description: 'Recognized by Govt. of Uttar Pradesh, Registration No. R/STARTUP/UP/LKO/2025/00007340',
      icon: 'fas fa-id-card',
      date: '2025'
    },
    {
      title: 'NIDHI Registered',
      description: 'NIDHI ID: EUP000449',
      icon: 'fas fa-registered',
      date: '2024'
    },
    {
      title: 'Safe & Honourable Tourism',
      description: 'Code of Conduct for Safe and Honourable Tourism Certified',
      icon: 'fas fa-hand-holding-heart',
      date: '2024'
    },
    {
      title: 'Sustainable Tourism Certified',
      description: 'Committed to environmental and heritage protection standards',
      icon: 'fas fa-globe-asia',
      date: '2024'
    },
    {
      title: 'Private Limited Company',
      description: 'Incorporated on October 11, 2022',
      icon: 'fas fa-chart-line',
      date: '2022'
    }
  ];

  // Certificates data from the PDF
  const certificates = [
    {
      id: 1,
      name: 'DPIIT Startup Recognition Certificate',
      description: 'Certificate of Recognition by Department for Promotion of Industry and Internal Trade',
      thumbnail: '/images/startup.jpg',
      fullSize: '/images/startup.jpg',
      issuer: 'Department for Promotion of Industry and Internal Trade, Government of India',
      date: '2025',
      registrationNo: 'Valid for 10 years from incorporation'
    },
        {
      id: 3,
      name: 'Startup UP Recognition Certificate',
      description: 'Government of Uttar Pradesh Startup Recognition',
      thumbnail: '/images/startupinindia.jpg',
      fullSize: '/images/startupinindia.jpg',
      issuer: 'Department of IT & Electronics, Gov of UP through UPLC',
      date: '2025',
      registrationNo: 'Reg No: R/STARTUP/UP/LKO/2025/00007340'
    },
    {
      id: 2,
      name: 'Best Tour and Travel Award',
      description: 'Presented by Bollywood Actor Tushar Kapur',
      thumbnail: '/images/bigopp.jpg',
      fullSize: '/images/bigopp.jpg',
      issuer: 'Bollywood Actor Tushar Kapur',
      date: '2025',
      registrationNo: 'Award for Excellence in Travel Services'
    },

    {
      id: 4,
      name: 'NIDHI Registration Certificate',
      description: 'National Initiative for Developing and Harnessing Innovations',
      thumbnail: '/images/nidhi.jpg',
      fullSize: '/images/nidhi.jpg',
      issuer: 'NIDHI - Government of India Initiative',
      date: '2024',
      registrationNo: 'NIDHI ID: EUP000449'
    }
  ];

  const openModal = (certificate) => {
    setSelectedCertificate(certificate);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCertificate(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <SEO 
        title="Awards & Recognition | RedGoTrip"
        description="RedGoTrip's official awards, startup recognitions from DPIIT and Government of UP, Best Tour and Travel Award by Tushar Kapur, and certified commitments to safe & sustainable tourism."
        keywords="RedGoTrip awards, DPIIT startup recognition, UP startup certificate, Tushar Kapur travel award, safe tourism, sustainable tourism, NIDHI registered"
      />

      <div className="awards-page">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-bg-pattern"></div>
          <div className="hero-content">
            <div className="hero-badge">
              <i className="fas fa-medal"></i>
              <span>Officially Recognized</span>
            </div>
            <h1 className="hero-title">
              Awards &<span className="gradient-text"> Recognition</span>
            </h1>
            <p className="hero-subtitle">
              RedGoTrip has been officially recognized by Government of India, Government of Uttar Pradesh,
              and honored with prestigious industry awards for excellence in travel services.
            </p>
            <div className="hero-stats">
              <div className="hero-stat">
                <span className="stat-number">2025</span>
                <span className="stat-label">Latest Award</span>
              </div>
              <div className="hero-stat">
                <span className="stat-number">DPIIT</span>
                <span className="stat-label">Govt. Recognition</span>
              </div>
              <div className="hero-stat">
                <span className="stat-number">UP Startup</span>
                <span className="stat-label">State Certified</span>
              </div>
            </div>
          </div>
        </section>

        {/* Awards Grid Section */}
        <section className="section awards-section">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">Our Achievements</span>
              <h2 className="section-title">Awards & Recognitions</h2>
              <p className="section-subtitle">
                Officially recognized by government bodies and honored with prestigious industry awards
              </p>
            </div>
            <div className="awards-grid">
              {awards.map((award) => (
                <div key={award.id} className="award-card">
                  <div className="award-icon-wrapper" style={{ background: `${award.color}15` }}>
                    <div className="award-icon" style={{ color: award.color }}>
                      <i className={award.icon}></i>
                    </div>
                  </div>
                  <div className="award-content">
                    <h3>{award.title}</h3>
                    <p className="award-org">{award.organization}</p>
                    <div className="award-year-badge">{award.year}</div>
                    <p className="award-desc">{award.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Certifications Section */}
        <section className="section certifications-section">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">Official Credentials</span>
              <h2 className="section-title">Certifications & Compliance</h2>
              <p className="section-subtitle">
                Fully registered and certified by government authorities
              </p>
            </div>
            <div className="certifications-grid">
              {certifications.map((cert, idx) => (
                <div key={idx} className="certification-card">
                  <div className="cert-icon-wrapper">
                    <i className={cert.icon}></i>
                  </div>
                  <div className="cert-info">
                    <h3>{cert.title}</h3>
                    <p>{cert.description}</p>
                    <span className="cert-year">{cert.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Certificates Gallery Section */}
        <section className="section certificates-gallery">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">Document Gallery</span>
              <h2 className="section-title">Official Certificates</h2>
              <p className="section-subtitle">
                View our official certificates and recognition documents
              </p>
            </div>
            <div className="certificates-grid">
              {certificates.map((certificate) => (
                <div key={certificate.id} className="certificate-card" onClick={() => openModal(certificate)}>
                  <div className="certificate-image-wrapper">
                    <img 
                      src={certificate.thumbnail} 
                      alt={certificate.name}
                      className="certificate-image"
                      loading="lazy"
                    />
                    <div className="certificate-overlay">
                      <div className="overlay-icon">
                        <i className="fas fa-search-plus"></i>
                      </div>
                      <span>View Certificate</span>
                    </div>
                  </div>
                  <div className="certificate-details">
                    <h3>{certificate.name}</h3>
                    <p className="cert-issuer">
                      <i className="fas fa-building"></i>
                      {certificate.issuer}
                    </p>
                    <p className="cert-date">
                      <i className="fas fa-calendar-alt"></i>
                      {certificate.date}
                    </p>
                    {certificate.registrationNo && (
                      <p className="cert-regno">
                        <i className="fas fa-qrcode"></i>
                        {certificate.registrationNo}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Company Info Section */}
        <section className="company-info-section">
          <div className="container">
            <div className="company-card">
              <div className="company-logo">
                <i className="fas fa-building"></i>
              </div>
              <div className="company-details">
                <h3>RedGoTrip Private Limited</h3>
                <p className="company-address">
                  <i className="fas fa-location-dot"></i>
                  No. 542/388, B-H-S, Allahpur, Allahabad, Paragana Sadar, Prayagraj, Uttar Pradesh
                </p>
                <div className="company-meta">
                  <span className="meta-tag">
                    <i className="fas fa-calendar-check"></i>
                    Incorporated: October 11, 2022
                  </span>
                  <span className="meta-tag">
                    <i className="fas fa-chart-line"></i>
                    CIN: Available on Request
                  </span>
                </div>
                <div className="company-ceo">
                  <img 
                    src="https://placehold.co/60x60/8b5cf6/white?text=SP" 
                    alt="Er. Surya Pratap Singh"
                    className="ceo-image"
                  />
                  <div className="ceo-info">
                    <strong>Er. Surya Pratap Singh</strong>
                    <span>Managing Director, NIT 2015</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="container">
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">2019</div>
                <p className="stat-label">Founded</p>
              </div>
              <div className="stat-item">
                <div className="stat-number">2022</div>
                <p className="stat-label">Incorporated</p>
              </div>
              <div className="stat-item">
                <div className="stat-number">DPIIT</div>
                <p className="stat-label">Govt. Recognized</p>
              </div>
              <div className="stat-item">
                <div className="stat-number">UP Startup</div>
                <p className="stat-label">State Certified</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Certificate Modal */}
      {isModalOpen && selectedCertificate && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeModal}>
              <i className="fas fa-times"></i>
            </button>
            <div className="modal-content">
              <div className="modal-image-wrapper">
                <img 
                  src={selectedCertificate.fullSize} 
                  alt={selectedCertificate.name}
                  className="modal-image"
                />
              </div>
              <div className="modal-info">
                <h3>{selectedCertificate.name}</h3>
                <div className="modal-info-item">
                  <i className="fas fa-building"></i>
                  <span><strong>Issued by:</strong> {selectedCertificate.issuer}</span>
                </div>
                <div className="modal-info-item">
                  <i className="fas fa-calendar-alt"></i>
                  <span><strong>Year:</strong> {selectedCertificate.date}</span>
                </div>
                {selectedCertificate.registrationNo && (
                  <div className="modal-info-item">
                    <i className="fas fa-qrcode"></i>
                    <span><strong>Registration No:</strong> {selectedCertificate.registrationNo}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .awards-page {
          background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
          min-height: 100vh;
        }

        /* Hero Section */
        .hero-section {
          position: relative;
          background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #2e1065 100%);
          padding: 200px 24px 30px;
          overflow: hidden;
        }

        .hero-bg-pattern {
          position: absolute;
          inset: 0;
          background-image: radial-gradient(circle at 2px 2px, rgba(255,255,255,0.05) 1px, transparent 1px);
          background-size: 40px 40px;
          opacity: 0.5;
        }

        .hero-content {
          max-width: 1200px;
          margin: 0 auto;
          text-align: center;
          position: relative;
          z-index: 1;
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,255,255,0.1);
          backdrop-filter: blur(10px);
          padding: 8px 20px;
          border-radius: 100px;
          margin-bottom: 24px;
          border: 1px solid rgba(255,255,255,0.2);
        }

        .hero-badge i {
          color: #fbbf24;
          font-size: 0.9rem;
        }

        .hero-badge span {
          color: white;
          font-size: 0.85rem;
          font-weight: 500;
          letter-spacing: 0.5px;
        }

        .hero-title {
          font-size: 3.5rem;
          font-weight: 800;
          color: white;
          margin-bottom: 20px;
          line-height: 1.2;
        }

        .gradient-text {
          background: linear-gradient(135deg, #fbbf24, #ec4899, #8b5cf6);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .hero-subtitle {
          font-size: 1.25rem;
          color: rgba(255,255,255,0.8);
          max-width: 700px;
          margin: 0 auto 40px;
          line-height: 1.6;
        }

        .hero-stats {
          display: flex;
          justify-content: center;
          gap: 48px;
          flex-wrap: wrap;
        }

        .hero-stat {
          text-align: center;
        }

        .hero-stat .stat-number {
          font-size: 2rem;
          font-weight: 800;
          color: #fbbf24;
          display: block;
          margin-bottom: 4px;
        }

        .hero-stat .stat-label {
          font-size: 0.85rem;
          color: rgba(255,255,255,0.7);
          letter-spacing: 0.5px;
        }

        /* Section Styles */
        .section {
          padding: 80px 24px;
        }

        .container {
          max-width: 1280px;
          margin: 0 auto;
        }

        .section-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .section-tag {
          display: inline-block;
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 2px;
          color: #8b5cf6;
          background: #f3e8ff;
          padding: 6px 14px;
          border-radius: 100px;
          margin-bottom: 16px;
        }

        .section-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 16px;
        }

        .section-subtitle {
          font-size: 1.1rem;
          color: #64748b;
          max-width: 600px;
          margin: 0 auto;
        }

        /* Awards Grid */
        .awards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 32px;
        }

        .award-card {
          background: white;
          border-radius: 24px;
          overflow: hidden;
          transition: all 0.3s ease;
          box-shadow: 0 4px 20px rgba(0,0,0,0.05);
          border: 1px solid rgba(0,0,0,0.05);
        }

        .award-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }

        .award-icon-wrapper {
          padding: 32px 24px 16px;
          text-align: center;
        }

        .award-icon {
          width: 70px;
          height: 70px;
          background: white;
          border-radius: 20px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 2.2rem;
          box-shadow: 0 10px 25px -5px rgba(0,0,0,0.1);
        }

        .award-content {
          padding: 0 24px 32px;
        }

        .award-content h3 {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 8px;
        }

        .award-org {
          color: #8b5cf6;
          font-weight: 500;
          font-size: 0.85rem;
          margin-bottom: 12px;
        }

        .award-year-badge {
          display: inline-block;
          background: #f1f5f9;
          padding: 4px 12px;
          border-radius: 100px;
          font-size: 0.75rem;
          font-weight: 600;
          color: #475569;
          margin-bottom: 16px;
        }

        .award-desc {
          color: #64748b;
          font-size: 0.9rem;
          line-height: 1.6;
          margin: 0;
        }

        /* Certifications Section */
        .certifications-section {
          background: #f8fafc;
        }

        .certifications-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        .certification-card {
          background: white;
          border-radius: 20px;
          padding: 24px;
          display: flex;
          align-items: center;
          gap: 16px;
          transition: all 0.3s ease;
          border: 1px solid #e2e8f0;
        }

        .certification-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 10px 25px -5px rgba(0,0,0,0.08);
          border-color: #cbd5e1;
        }

        .cert-icon-wrapper {
          width: 56px;
          height: 56px;
          background: linear-gradient(135deg, #8b5cf6, #a855f7);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .cert-icon-wrapper i {
          font-size: 1.5rem;
          color: white;
        }

        .cert-info {
          flex: 1;
        }

        .cert-info h3 {
          font-size: 1rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 4px;
        }

        .cert-info p {
          font-size: 0.8rem;
          color: #64748b;
          margin: 0 0 4px 0;
        }

        .cert-year {
          font-size: 0.7rem;
          color: #8b5cf6;
          font-weight: 600;
        }

        /* Certificates Gallery */
        .certificates-gallery {
          background: white;
        }

        .certificates-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 32px;
        }

        .certificate-card {
          background: white;
          border-radius: 20px;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0,0,0,0.05);
          border: 1px solid #e2e8f0;
        }

        .certificate-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 35px -10px rgba(0,0,0,0.15);
        }

        .certificate-image-wrapper {
          position: relative;
          aspect-ratio: auto;
          overflow: hidden;
          background: #f1f5f9;
        }

        .certificate-image {
          width: 100%;
          height: auto;
          object-fit: contain;
          transition: transform 0.4s ease;
        }

        .certificate-card:hover .certificate-image {
          transform: scale(1.05);
        }

        .certificate-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.6);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
          opacity: 0;
          transition: opacity 0.3s ease;
          backdrop-filter: blur(4px);
        }

        .certificate-card:hover .certificate-overlay {
          opacity: 1;
        }

        .overlay-icon {
          width: 48px;
          height: 48px;
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .overlay-icon i {
          font-size: 1.25rem;
          color: #1e293b;
        }

        .certificate-overlay span {
          color: white;
          font-size: 0.85rem;
          font-weight: 500;
        }

        .certificate-details {
          padding: 20px;
        }

        .certificate-details h3 {
          font-size: 1rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 12px;
        }

        .cert-issuer, .cert-date, .cert-regno {
          font-size: 0.8rem;
          color: #64748b;
          margin: 8px 0;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .cert-issuer i, .cert-date i, .cert-regno i {
          width: 20px;
          color: #8b5cf6;
        }

        /* Company Info Section */
        .company-info-section {
          padding: 60px 24px;
          background: linear-gradient(135deg, #f3e8ff, #e0f2fe);
        }

        .company-card {
          background: white;
          border-radius: 32px;
          padding: 40px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .company-logo {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #8b5cf6, #a855f7);
          border-radius: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
        }

        .company-logo i {
          font-size: 2.5rem;
          color: white;
        }

        .company-details h3 {
          font-size: 1.75rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 16px;
        }

        .company-address {
          color: #64748b;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .company-address i {
          color: #8b5cf6;
        }

        .company-meta {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 16px;
          margin-bottom: 24px;
        }

        .meta-tag {
          background: #f1f5f9;
          padding: 6px 14px;
          border-radius: 100px;
          font-size: 0.8rem;
          color: #475569;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .meta-tag i {
          color: #8b5cf6;
        }

        .company-ceo {
          display: inline-flex;
          align-items: center;
          gap: 16px;
          background: #f8fafc;
          padding: 12px 24px;
          border-radius: 100px;
        }

        .ceo-image {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          object-fit: cover;
          background: #8b5cf6;
        }

        .ceo-info {
          text-align: left;
        }

        .ceo-info strong {
          display: block;
          color: #1e293b;
          font-size: 0.95rem;
        }

        .ceo-info span {
          font-size: 0.8rem;
          color: #64748b;
        }

        /* Stats Section */
        .stats-section {
          background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%);
          padding: 80px 24px;
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 40px;
          text-align: center;
        }

        .stat-item .stat-number {
          font-size: 2.5rem;
          font-weight: 800;
          color: #fbbf24;
          margin-bottom: 8px;
        }

        .stat-item .stat-label {
          font-size: 0.9rem;
          color: rgba(255,255,255,0.8);
          letter-spacing: 0.5px;
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.85);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 20px;
          backdrop-filter: blur(8px);
          animation: fadeIn 0.2s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .modal-container {
          max-width: 90vw;
          max-height: 90vh;
          background: white;
          border-radius: 24px;
          overflow: hidden;
          position: relative;
          animation: slideUp 0.3s ease;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .modal-close-btn {
          position: absolute;
          top: 16px;
          right: 16px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(0,0,0,0.5);
          border: none;
          color: white;
          font-size: 1.2rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          z-index: 10;
          backdrop-filter: blur(4px);
        }

        .modal-close-btn:hover {
          background: rgba(0,0,0,0.8);
          transform: rotate(90deg);
        }

        .modal-content {
          display: flex;
          flex-direction: column;
        }

        .modal-image-wrapper {
          max-height: 70vh;
          overflow: hidden;
          background: #f1f5f9;
        }

        .modal-image {
          width: 100%;
          height: auto;
          object-fit: contain;
        }

        .modal-info {
          padding: 24px;
          background: white;
        }

        .modal-info h3 {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 16px;
        }

        .modal-info-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
          color: #475569;
          font-size: 0.9rem;
        }

        .modal-info-item i {
          width: 20px;
          color: #8b5cf6;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .hero-title {
            font-size: 2.3rem;
          }
          
          .hero-subtitle {
            font-size: 1rem;
          }
          
          .hero-stats {
            gap: 24px;
          }
          
          .section-title {
            font-size: 1.8rem;
          }
          
          .awards-grid,
          .certifications-grid,
          .certificates-grid,
          .testimonials-grid {
            grid-template-columns: 1fr;
          }
          
          .modal-container {
            max-width: 95vw;
          }
          
          .stats-grid {
            gap: 24px;
          }
          
          .stat-item .stat-number {
            font-size: 2rem;
          }
          
          .company-card {
            padding: 24px;
          }
          
          .company-meta {
            flex-direction: column;
            align-items: center;
          }
          
          .company-ceo {
            flex-direction: column;
            text-align: center;
          }
          
          .ceo-info {
            text-align: center;
          }
        }
      `}</style>
    </>
  );
};

export default Awards;